import { Spin } from "antd";
import React, { useState } from "react";
import PlaygoundComponent from "./playgound.component";
import "./playground.css";

const PlaygroundContainer = () => {
  const [spinning, setSpinning] = useState(false);
  const [responseData, setResponseData] = useState();
  const [drawerData, setDrawerData] = useState();
  return (
    <div className="playground-container">
      <Spin spinning={spinning} wrapperClassName="playground-spin-wrapper">
        <PlaygoundComponent
          responseData={responseData}
          setResponseData={setResponseData}
          spinning={spinning}
          setSpinning={setSpinning}
          drawerData={drawerData}
          setDrawerData={setDrawerData}
        />
      </Spin>
    </div>
  );
};

export default PlaygroundContainer;
